import styled from 'styled-components';

import Dialog from '@mui/material/Dialog';

export const Modal = styled(Dialog)`
  .MuiPaper-root {
    padding: 24px;
    border-radius: 8px;
    border: 0px solid ${({ theme }) => theme.palette.grey[200]};
    background: ${({ theme }) => theme.palette.common.white};
    box-shadow: ${({ theme }) => theme.shadows.card};
  }
`;

export const CustomModalTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CustomModalActions = styled.div<{ $buttonsSpacing?: string }>`
  display: flex;
  justify-content: ${($props) => ($props.$buttonsSpacing ? $props.$buttonsSpacing : 'flex-end')};
  gap: 10px;
  margin-top: 24px;
`;

export const StyledModalTitle = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 20px;
  font-weight: 500;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin: 0;
`;

export const CustomModalDescription = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin-top: 10.6px;
  margin-bottom: 16px;
`;
